import {
  AdminCategoryItemDto,
  SupplierCategoryItemDto,
} from "@semo/api-contracts";
import { Product } from "../types";

/**
 * Maps Supplier API DTO to Unified Product Type
 */
export function mapSupplierProductToDomain(
  dto: SupplierCategoryItemDto,
): Product {
  // Directly assign if compatible, otherwise use spread
  const product: Product = { ...dto };
  return product;
}

/**
 * Maps Admin API DTO to Unified Product Type
 */
export function mapAdminProductToDomain(dto: AdminCategoryItemDto): Product {
  // AdminCategoryItemDto structure matches Product base
  const product: Product = { ...dto };
  return product;
}
